import { render, staticRenderFns } from "./MailtplEditNew.vue?vue&type=template&id=2fcfe202&"
import script from "./MailtplEditNew.vue?vue&type=script&lang=js&"
export * from "./MailtplEditNew.vue?vue&type=script&lang=js&"
import style0 from "./MailtplEditNew.vue?vue&type=style&index=0&id=2fcfe202&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports